import { extractInvokeDownloadAction } from '../../action/extract-invoke-download-action';
export var extractDownloadClientAction = function extractDownloadClientAction(param) {
  var invokeAction = extractInvokeDownloadAction(param);
  return invokeAction ? {
    invokeAction: invokeAction
  } : undefined;
};